<div class="copyright">
  版权所有 Copyright <a style="color: #666;margin-right:8px" href="http://www.fine1.cn">©深圳饭碗农业物联网科技有限公司</a>
  |
  <a style="color: #666;margin-left:8px" href="https://beian.miit.gov.cn">{{ icpNo }}</a>
</div>
